import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
// Self-hosted, not fonts.googleapis.com: the stylesheets reference Inter and
// JetBrains Mono by family name, so a blocked or slow CDN silently reflows the
// whole product into a fallback face — and every load would tell Google who is
// reading their mail.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource-variable/jetbrains-mono";
import "./styles/signin.css";
import "./styles/mail.css";
import { applyTheme, storedTheme } from "./lib/theme";

// Before React mounts, so a light-theme user does not get a flash of the dark
// palette on every load.
applyTheme(storedTheme());

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
